import React, { useEffect, useMemo, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import classNames from 'classnames/bind';
import qs from 'qs';
import { useHistory } from 'react-router-dom';
import PasswordInput from 'templates/LoginPageData/components/PasswordInput/PasswordInput';
import PageLink from 'components/PageLink/PageLink';
import Modal from 'components/Modal/Modal';
import Icon from 'components/Icon/Icon';
import { SvgIcons } from 'common/consts/svgIcons';
import { fetcher } from 'app/http';
import { getPathnameFromUrl } from 'common/helpers/resolveHost';
import styles from './ResetPasswordPageData.module.scss';
import TagManager from 'react-gtm-module';
import { getEncryptedValue } from 'common/helpers/Gtm';
import { formError, formProgression } from 'common/helpers/Gtm';
import {
  REGEXP_PASS_STRONG,
  PASSWORD_STRENGTH,
  getPasswordStength,
} from 'common/helpers/valdiation';
type Props = {
  Model: any;
  PageData: any;
  OnCancel?: any;
  LayoutModel?: any;
};

const ResetPasswordPageData = ({
  Model,
  PageData,
  OnCancel,
  LayoutModel,
}: Props) => {
  const history = useHistory();
  const [showPasswordConfirm, setShowPasswordConfirm] =
    useState<boolean>(false);
  const [showPasswordPolicy, setShowPasswordPolicy] = useState<boolean>(false);
  const [resetSuccess, setResetSuccess] = useState<boolean>(false);
  const [currentPasswordInvalid, setCurrentPasswordInvalid] =
    useState<boolean>(false);
  const [patternCheck, SetPatternCheck] = useState<any>(0);
  const {
    control,
    register,
    watch,
    handleSubmit,
    formState: { errors, isValid, isDirty },
    getFieldState,
  } = useForm({
    defaultValues: {
      authid: Model?.AuthId,
      email: Model?.EmailAddress,
      password: Model?.NewPassword || '',
      confirmPassword: Model?.ConfirmPassword || '',
      currentPassword: Model?.CurrentPassword || '',
    },
    mode: 'all',
  });

  const disabledSubmit = useMemo(() => {
    // Disable on submit

    // Enable when is filled and is valid
    if (isDirty && isValid) {
      return false;
    }
    // Disable by default
    SetPatternCheck(1);
    return true;
  }, [isDirty, isValid]);

  useEffect(() => {
    if (Model?.showSuccessfulReset) {
      setResetSuccess(true);
    }
  }, [Model?.showSuccessfulReset]);

  const trackPasswordResetSuccessEvent = () => {
    var tagManagerArgs: any;
    if (Model?.DebtReference) {
      let encodedUserId = getEncryptedValue(
        Model?.DebtReference,
        LayoutModel?.CountryCode,
      );
      tagManagerArgs = {
        dataLayer: {
          event: 'forgot_password_success',
          reset_type: 'Password',
          user_id: encodedUserId,
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    } else {
      tagManagerArgs = {
        dataLayer: {
          event: 'forgot_password_success',
          reset_type: 'Password',
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    }
  };
  const onFocusOutResetPasswordCurrent = async (e: any) => {
    formProgression(e, 'PasswordReset', 'CurrentPassword');
  };
  const onFocusOutResetPasswordConfirm = async (e: any) => {
    formProgression(e, 'PasswordReset', 'ConfirmPassword');
  };
  const passwordState = getFieldState('password');
  const confirmPasswordState = getFieldState('confirmPassword');
  const currentPasswordState = getFieldState('currentPassword');

  const handleInput = (e: any, callback: Function) => {
    const patterStength = getPasswordStength(e);
    if (patterStength !== 'strong') {
      SetPatternCheck(1);
    } else {
      SetPatternCheck(0);
    }
    callback(e);
  };
  useEffect(() => {
    if (passwordState.error !== undefined) {
      formError('PasswordReset', 'Password', 'error_Incorrect_Password');
    }
  }, [passwordState]);

  useEffect(() => {
    if (confirmPasswordState.error !== undefined) {
      formError(
        'PasswordReset',
        'confirmPassword',
        'error_Passwords_donot_match',
      );
    }
  }, [confirmPasswordState]);
  useEffect(() => {
    if (currentPasswordState.error !== undefined) {
      formError(
        'PasswordReset',
        'currentPassword',
        'error_Enter_Your_Current_Password',
      );
    }
  }, [currentPasswordState]);

  // Watch current password for validation purpose - is equal with password confirmation
  const currentPasssword = watch('password');

  const onFormSubmit = handleSubmit(async (data) => {
    try {
      if (Model?.IsCustomerProfileStage) {
        delete data?.confirmPassword;
        const response = await fetcher.put(Model.NextUrl, qs.stringify(data));
        if (response && response.data?.status === 'error') {
          const redirectPath = getPathnameFromUrl(response.data.data);
          history.push(redirectPath);
        }
        if (response && response.data?.status === 'redirect') {
          trackPasswordResetSuccessEvent();
          window.location.href = response.data?.data;
          detailsResetPasswordTracking();
        }

        if (response && response.data?.status === 'invalidPassword') {
          setCurrentPasswordInvalid(true);
        }
      } else {
        delete data?.confirmPassword;
        const response = await fetcher.put(Model.NextUrl, qs.stringify(data));
        if (response && response.data?.status === 'error') {
          const redirectPath = getPathnameFromUrl(response.data.data);
          history.push(redirectPath);
        }
        if (response && response.data?.status === 'redirect') {
          trackPasswordResetSuccessEvent();
          setResetSuccess(true);
          detailsResetPasswordTracking();
        }
      }
    } catch (error) {
      console.error(error);
    }
  });
  var tagManagerArgs: any;
  const detailsResetPasswordTracking = () => {
    tagManagerArgs = {
      dataLayer: {
        event: 'edit_profile',
        edit_section: 'Password',
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  };
  return (
    <form onSubmit={onFormSubmit} className={styles.wrapper}>
      {resetSuccess ? (
        <div
          className="Page-container PageContainer--transparent"
          id="passwordsuccessDiv"
        >
          <div className="auth0-container">
            <div className="form-heading u-textCenter">
              {PageData?.PasswordResetSuccessTextLabel}
            </div>
            <div>
              <p className="form-text u-textCenter">
                {PageData?.PasswordResetSuccessTextInfo}
              </p>
            </div>
            <div className="u-marginTxsm u-textCenter">
              <PageLink
                url={Model?.LoginUrl}
                text={PageData?.ContinueToLoginText}
                className={styles.continueBtn}
              />
            </div>
          </div>
        </div>
      ) : (
        <div
          className="Page-container PageContainer--transparent"
          id="PasswordResetDiv"
        >
          <div className="auth0-container">
            <div className="form-heading">{PageData?.Header}</div>
            {Model?.IsCustomerProfileStage && (
              <div className="form-text">
                {PageData?.ChangePasswordNoteText}
              </div>
            )}
            <div className="form-group">
              <input
                {...register('authid')}
                type="hidden"
                value={Model?.AuthId}
              />
              <input
                {...register('email')}
                type="hidden"
                value={Model?.EmailAddress}
              />
              {Model?.IsCustomerProfileStage && (
                <div className={styles.fieldWrapper}>
                  <Controller
                    control={control}
                    name={'currentPassword'}
                    render={({
                      field: { onChange, name, value },
                      fieldState: { error },
                    }) => (
                      <PasswordInput
                        name={name}
                        label={PageData?.CurrentPasswordLabel}
                        value={value}
                        error={error}
                        onChange={onChange}
                        onFocusOut={(e) => {
                          onFocusOutResetPasswordCurrent(e);
                        }}
                      />
                    )}
                    rules={{
                      required: {
                        value: true,
                        message: PageData?.EnterYourCurrentPasswordText,
                      },
                    }}
                  />
                </div>
              )}

              {Model?.IsCustomerProfileStage && currentPasswordInvalid && (
                <p className="error u-marginBxsm">
                  {PageData?.CurrentPasswordIncorrectLabel}
                </p>
              )}
              <div
                className={classNames(
                  styles.fieldWrapper,
                  styles.withStrengthMeter,
                )}
              >
                <Controller
                  control={control}
                  name={'password'}
                  render={({
                    field: { onChange, name, value },
                    fieldState: { error },
                  }) => (
                    <PasswordInput
                      name={name}
                      label={PageData?.NewPasswordLabel}
                      value={value}
                      error={error}
                      showPassword
                      showPasswordStrength
                      onChange={(newPassword: string) => {
                        setShowPasswordConfirm(true);
                        onChange(newPassword);
                        handleInput(newPassword, onChange);
                      }}
                      onFocusOut={(e) => {
                        onFocusOutResetPasswordCurrent(e);
                      }}
                    />
                  )}
                  rules={{
                    minLength: {
                      value: 8,
                      message: PageData?.PasswordLengthMessage,
                    },
                  }}
                />
              </div>
              {(showPasswordConfirm || Model?.IsCustomerProfileStage) && (
                <div className={styles.fieldWrapper}>
                  <Controller
                    control={control}
                    name={'confirmPassword'}
                    render={({
                      field: { onChange, name, value },
                      fieldState: { error },
                    }) => (
                      <PasswordInput
                        name={name}
                        label={PageData?.ConfirmNewPasswordLabel}
                        value={value}
                        error={error}
                        onChange={(e) => handleInput(e, onChange)}
                        onFocusOut={(e) => {
                          onFocusOutResetPasswordConfirm(e);
                        }}
                      />
                    )}
                    rules={{
                      validate: {
                        isEqual: (val) =>
                          val === currentPasssword ||
                          PageData?.PasswordDonotMatchText ||
                          'Passwords do not match',
                      },
                    }}
                  />
                </div>
              )}
            </div>
            <button
              type="button"
              onClick={() => setShowPasswordPolicy(!showPasswordPolicy)}
              className={classNames(
                styles.passwordLengthInfo,
                !PageData?.PasswordLengthMessageInfo && styles.inactive,
              )}
            >
              {PageData?.PasswordLengthMessage}{' '}
              <Icon
                type={SvgIcons.INFO}
                width={16}
                className={styles.iconInfo}
              />
            </button>
            <div className="u-marginTxsm u-textCenter">
              {!Model?.IsCustomerProfileStage ? (
                <button
                  type="submit"
                  disabled={!isValid}
                  className={classNames(
                    styles.submitBtn,
                    !isValid && styles.disabled,
                    patternCheck && styles.disabled,
                  )}
                >
                  {PageData?.ConfirmButtonText}
                </button>
              ) : (
                <button
                  className={classNames(
                    styles.submitBtn,
                    disabledSubmit && styles.disabled,
                    patternCheck && styles.disabled,
                  )}
                  type="submit"
                  disabled={disabledSubmit}
                >
                  {PageData?.ConfirmButtonText}
                </button>
              )}
              {Model?.IsCustomerProfileStage && (
                <button
                  type="button"
                  className="Button w-100 Button--ghost gray-border u-marginTxsm"
                  onClick={() => OnCancel(false)}
                >
                  {PageData?.CancelButtonText}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
      {showPasswordPolicy && PageData?.PasswordLengthMessageInfo && (
        <Modal showCloseButton onClose={() => setShowPasswordPolicy(false)}>
          <div className={styles.passwordPolicy}>
            {PageData?.PasswordLengthMessageInfo}
          </div>
        </Modal>
      )}
    </form>
  );
};

export default ResetPasswordPageData;
